export default {
    settings: {
        title: 'ГЛОБАЛНА ПОДЕШАВАЊА',
        mainMenu: 'Главни мени',
        footerMenu: 'Футер мени',
        phone: 'Телефон',
        fax: 'Факс',
        email: 'Е-пошта',
        address: 'Адреса',
        city: 'Град',
        categoryId: 'Category IDs',
        numDocument: 'Num. of documents per category',
        save: 'Сачувај'
    },
    menu: {
        position: 'Позиција',
        parent: 'Парент',
        pageOfUrl: 'УРЛ странице'
    }
};